<script>
export default {
  computed: {
    groupedConfiguration() {
      const groups = this.configuration.reduce((groups, parameter) => {
        const {
          type,
          type_name,
          type_product_configuration_type_code,
          type_description,
          required,
          ...configuration
        } = parameter

        if (!(type in groups)) {
          groups[type] = {
            _id: type,
            name: type_name,
            code: type_product_configuration_type_code,
            description: type_description,
            required,
            configurations: [],
          }
        }

        groups[type].configurations.push(configuration)

        return groups
      }, {})

      return Object.values(groups)
    },
  },
}
</script>
